import React from 'react';

const KPIPanel = ({ delay }) => {
  const weatherDays = [
    { day: 'MON', icon: '☀️', temp: '36°' },
    { day: 'TUE', icon: '⛅', temp: '36°' },
    { day: 'WED', icon: '☀️', temp: '36°' },
    { day: 'THU', icon: '☀️', temp: '36°' },
    { day: 'FRI', icon: '⛅', temp: '36°' },
  ];

  return (
    <div className="panel kpi-panel" style={{ animationDelay: delay }}>
      <div className="ph">
        <div className="pt">
          <div className="pdot" style={{ background: '#f59e0b', boxShadow: '0 0 0 2px rgba(245,158,11,.2)' }}></div>
          Key Metrics
        </div>
      </div>
      <div className="kpi-body">
        <div className="ki" style={{ background: 'linear-gradient(135deg,#f0fdf4,#dcfce7)', border: '1px solid #bbf7d0' }}>
          <div className="ki-lbl" style={{ color: '#15803d' }}>CO₂ Emission</div>
          <div className="ki-val" style={{ color: '#15803d' }}>1,000 <small style={{ fontSize: '12px', fontWeight: '600', opacity: '.6' }}>KG</small></div>
          <div className="ki-track">
            <div className="ki-fill" style={{ width: '72%', background: 'linear-gradient(90deg,#4ade80,#16a34a)' }}></div>
          </div>
        </div>
        <div className="ki" style={{ background: 'linear-gradient(135deg,#fffbeb,#fef3c7)', border: '1px solid #fde68a' }}>
          <div className="ki-lbl" style={{ color: '#92400e' }}>CO₂ Savings</div>
          <div className="ki-val" style={{ color: '#b45309' }}>8 <small style={{ fontSize: '12px', fontWeight: '600', opacity: '.6' }}>%</small></div>
          <div className="ki-track">
            <div className="ki-fill" style={{ width: '8%', background: 'linear-gradient(90deg,#fcd34d,#d97706)' }}></div>
          </div>
        </div>
        <div className="ki" style={{ background: 'linear-gradient(135deg,#ecfeff,#cffafe)', border: '1px solid #a5f3fc' }}>
          <div className="ki-lbl" style={{ color: '#0e7490' }}>Water Positivity</div>
          <div className="ki-val" style={{ color: '#0891b2' }}>±1.25</div>
          <div className="ki-track">
            <div className="ki-fill" style={{ width: '62%', background: 'linear-gradient(90deg,#67e8f9,#0891b2)' }}></div>
          </div>
        </div>
        <div className="ki" style={{ background: 'linear-gradient(135deg,#eff6ff,#dbeafe)', border: '1px solid #bfdbfe' }}>
          <div className="ki-lbl" style={{ color: '#1d4ed8' }}>Renewable</div>
          <div className="ki-val" style={{ color: '#2563eb' }}>25 <small style={{ fontSize: '12px', fontWeight: '600', opacity: '.6' }}>%</small></div>
          <div className="ki-track">
            <div className="ki-fill" style={{ width: '25%', background: 'linear-gradient(90deg,#93c5fd,#2563eb)' }}></div>
          </div>
        </div>
        <div className="wx">
          <div className="wx-city">📍 Chennai, India</div>
          <div className="wx-main">
            <div className="wx-temp">37°</div>
            <div className="wx-sun">☀️</div>
          </div>
          <div className="wx-desc">Sunny to partly cloudy · Very warm</div>
          <div className="wx-days">
            {weatherDays.map((day, idx) => (
              <div key={idx} className="wxd">
                <div className="wxd-n">{day.day}</div>
                <div className="wxd-i">{day.icon}</div>
                <div className="wxd-t">{day.temp}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KPIPanel;
